import React from 'react';

import { FormattedMessage } from 'react-intl';

import { WARNING_SEVERITY } from '../../components/compact-error/constants';
import CompactError from '../../components/compact-error/index';
import { ComponentStates } from '../../enums/component-states';
import { useFulfillmentPlannerContext } from '../context';
import { useIsFulfillmentPlanThirdPartyBilling } from '../hooks/use-is-fulfillment-plan-third-party-billing';
import { useIsTikTokShippingOrder } from '../hooks/use-is-tiktok-shipping-order';
import RateAmount from '../rate/rate-amount';
import RateRefresher from '../rate/rate-refresher';
import messages from './messages';
import RateErrorLabel from './rate-error-label';
import RateWarningLabel from './rate-warning-label';
import RateProvidedLabel from './rate-provided-label';
import ThirdPartyBillingTooltip from './third-party-billing-tooltip';
import { useRateWarningsAndErrors } from './use-rate-warnings-and-errors';
import { OrderRateWarningTooltip } from './rate-warning-tooltip/order-rate-warning-tooltip';

import style from './style.module.less';
import { getMessageDescriptorOrStringFromErrorString } from '../../errors/user-friendly-error-message-service/error-string-matching-to-formatted-message';

const Rate = () => {
  const { fulfillmentPlanId, uiRestrictions, otherShippingOptions, serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext();

  const isThirdPartyBilling = useIsFulfillmentPlanThirdPartyBilling(serviceIdAndSellerLabelProviderId.serviceId, otherShippingOptions);
  const isTikTokShipping = useIsTikTokShippingOrder(fulfillmentPlanId);

  const { shouldShowWarnings, shouldShowErrors, warnings, errors, errorSeverity } = useRateWarningsAndErrors();

  const treatedWarnings = warnings.map((warn) => getMessageDescriptorOrStringFromErrorString(warn));

  const rateProvided = uiRestrictions?.rateSummary?.componentState === ComponentStates.Provided && !isTikTokShipping;

  if (isThirdPartyBilling) {
    return (
      <div>
        <div className={style['rate-label']}>
          <FormattedMessage {...messages.rateLabel} />
        </div>
        <div className={style['rate-and-refresh']}>
          <ThirdPartyBillingTooltip />
          <RateAmount shouldShowRate={false} />
          <div className={style['refresh-wrapper']}>
            <RateRefresher />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={style['rate-label']}>
        <FormattedMessage {...messages.rateLabel} />
        <OrderRateWarningTooltip />
      </div>
      {!rateProvided ? (
        <div className={style['rate-and-refresh']}>
          {shouldShowWarnings && <CompactError errorMessages={treatedWarnings} severity={WARNING_SEVERITY} title={RateWarningLabel} />}
          {shouldShowErrors ? <CompactError errorMessages={errors} severity={errorSeverity} title={RateErrorLabel} /> : <RateAmount />}
          <div className={style['refresh-wrapper']}>
            <RateRefresher />
          </div>
        </div>
      ) : (
        <RateProvidedLabel />
      )}
    </div>
  );
};

export default Rate;
